import * as types from "./types";

export const fetchingExpenses = () => ({
  type: types.FETCHING_EXPENSES,
  loading: true
});

export const deletingExpense = () => ({
  type: types.DELETING_EXPENSE,
  loading: true
});

export const addingExpense = () => ({
  type: types.ADDING_EXPENSE,
  loading: true
});

export const addedExpense = (expense) => ({
  type: types.ADDED_EXPENSE,
  expense: expense,
  loading: false
});

export const deletedExpense = (expense) => ({
  type: types.DELETED_EXPENSE,
  expense: expense,
  loading: false
});

export const fetchedExpenses=(expenses, productId)=>({
  type: types.FETCHED_EXPENSES,
  expenses: expenses,
  productId: productId,
  loading: false
});

export const errorFetchingExpenses = (error) => ({
  type: types.ERROR_FETCHING_EXPENSES,
  error: error,
  loading: false
});

export const errorAddingExpense = (error) => ({
  type: types.ERROR_ADD_EXPENSE,
  error: error,
  loading: false
});

export const errorDeletingExpense = (error) => ({
  type: types.ERROR_DELETING_EXPENSE,
  error: error,
  loading: false
});